import Action from '../../model/Action'
import State from '../../model/State'

export function usuarioReducer(state: State, action: Action) {
    switch (action.type) {
    case 'setUsuario':
        return { ...state, usuario: action.payload }
    case 'setAuthenticated':
        return { ...state, authenticated: action.payload }
    default:
        return state
    }
}
